import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { AppUser } from "../pages/api";
import { APP_THEME, DEFAULT_LANGUAGE } from "../constants";
import { setCookie } from "../utils/cookie";

const initialState: AppUser = {
  user: null,
  language: DEFAULT_LANGUAGE,
  darkTheme: false,
};

export const appUserSlice = createSlice({
  name: "appUser",
  initialState,
  reducers: {
    setAppUser: (state: any, action: PayloadAction<AppUser>) => {
      state.user = action.payload.user;
    },
    setLanguage: (state: any, action: PayloadAction<string>) => {
      state.language = action.payload;
    },
    setDarkTheme: (state: any, action: PayloadAction<boolean>) => {
      setCookie(APP_THEME, action.payload ? "dark" : "light");
      state.darkTheme = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setAppUser, setLanguage, setDarkTheme } = appUserSlice.actions;

export default appUserSlice.reducer;
